import styled from "styled-components";
import Colors from "../../../../assets/Colors";

const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column-start: 1;
  grid-column-end: ${(props) => `${props.columns + 1}`};
  grid-template-columns: ${(props) => `${props.grid}`};
  display: grid;
  border-left: 3px solid transparent;
  padding-left: -3px;
  &:hover {
    background: ${Colors.primary}10;
    border-left: 3px solid ${Colors.primary};
  }
`;

const TableCell = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const state = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95px;
  height: 32px;
  background: ${Colors.ACTIVE_SUCCESS};
  color: #fff;
  font-size: 12px;
  font-weight: 500;
`;

const Line = styled.div`
  grid-column-start: 1;
  grid-column-end: ${(props) => `${props.columns + 1}`};
  height: 1px;
  border-bottom: 1px solid ${Colors.line_separator};
  width: 100%;
`;

export default {
  state,
  TableCell,
  Line,
  RowWrapper,
};
